import {
  htmlToProsemirror,
  newPin,
  newSlidePin,
  slideTitleWithBodytextLayout,
  stringToProsemirror,
} from '@lessonup/pins-shared';
import { AiToolsType } from '../../AiToolbox.types';

export const saveToLessonGenerators: AiToolsType[] = [
  'summary',
  'summaryWebsite',
  'translate',
  'rewrite',
  'lessonRecap',
  'debateTopics',
  'glossary',
  'quiz',
];

export const isSaveToLessonGenerator = (type: AiToolsType) => {
  return saveToLessonGenerators.includes(type);
};

export const getPinForGenerator = (title: string, html: string) => {
  return newPin(
    newSlidePin(
      slideTitleWithBodytextLayout({
        title: {
          content: stringToProsemirror(title, { bold: true }),
        },
        body: {
          content: htmlToProsemirror(html),
        },
      })
    )
  );
};
